// import './tooltip-styles.css'

const Tooltip = ({ children, text }) => {
    return (
        <div className="group relative inline-block">
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 z-50 opacity-0 transition ease-in-out group-hover:block group-hover:opacity-90">
                <div className='bg-black text-white px-4 py-2 rounded-md shadow-lg'>
                    <span>{text}</span>
                </div>
            </div>
            {children}
        </div>
    );
};

export default Tooltip;